<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Stock por Distribuidor</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <button v-if="campaign" class="btn btn-neutral btn-sm btn-wd" title="Descargar" @click="downloadPdf">
            <i class="fas fa-download"></i>&nbsp;Descargar PDF
          </button>
          <button v-if="campaign && distributor" class="btn base-button btn-neutral btn-sm" @click="clearFilters">
            Cambiar
          </button>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div v-show="!filterSelected" class="row justify-content-center">
        <div class="col-md-6 col-sm-8 col-xs-12 card-wrapper">
          <div class="card mb-4">
            <div class="card-header">
              <h3 class="mb-0">Elija campaña y distribuidor para listar los remitos</h3>
            </div>
            <div class="card-body">
              <campaign-select v-model="campaign" />
              <distributor-select v-if="!isDistributor" :key="inputRefreshKey" v-model="distributor" />
            </div>
          </div>
        </div>
      </div>

      <stock-by-distributor v-if="filterSelected" :distributor-id="distributor" />
    </div>
  </div>
</template>

<script>
import { Table, TableColumn } from 'element-ui';
import CampaignSelect from '@/components/ModelSelects/CampaignSelect';
import DistributorSelect from '@/components/ModelSelects/DistributorSelect';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import { isDistributor } from '@/util/roles';

import CurrentCampaignMixin from '@/mixins/currentCampaignMixin';

import StockByDistributor from './List/StockByDistributor.vue';

export default {
  name: 'ListByDistributor',
  components: {
    CampaignSelect,
    DistributorSelect,
    RouteBreadCrumb,
    StockByDistributor,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },

  mixins: [CurrentCampaignMixin],

  data() {
    return {
      isDataLoaded: false,
      inputRefreshKey: 0,
      distributor: null,
    };
  },

  computed: {
    filterSelected() {
      return this.campaign && this.distributor;
    },

    isDistributor() {
      return isDistributor(this.$auth.user());
    },
  },

  mounted() {
    if (this.$route.params.distributor) {
      this.distributor = this.$route.params.distributor;
    } else if (this.isDistributor) {
      this.distributor = this.$auth.user().data.roleData.id;
    }
  },

  methods: {
    clearFilters() {
      if (this.isDistributor) {
        this.campaign = null;
      } else {
        this.distributor = null;
      }
      this.inputRefreshKey++;
    },

    downloadPdf() {
      this.$services.resource('stocks').reportByDistributor(this.campaign, {
        distributor_id: this.distributor,
        filename: 'stock-por-distribuidor',
      });
    },
  },
};
</script>
